<main id="db-wrapper" class="bg-light">

  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>

  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation></app-only-admin-navigation>
    </div>

    <div *ngIf="loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center"
            >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{'ADMIN_PORTAL' | translate}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="row gx-3">
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center h-100 justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle" ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle" ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div
                  class="d-flex align-items-center justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle"></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card body -->
              <div class="card-body">
                <div class="d-flex justify-content-between mb-3 lh-1"
                >
                  <div>
                    <span
                      class="fs-6 text-uppercase fw-semibold"
                      style="height: 20px"
                    >
                      <div class="skeleton-card"></div>
                    </span>
                  </div>
                  <div style="height: 50px; width: 50px">
                    <div class="skeleton-circle"

                    ></div>
                  </div>
                </div>
                <h2 class="fw-bold mb-1">
                  <div class="skeleton-card" style="height: 20px"></div>
                </h2>
                <span class="text-success fw-semibold"
                  ><div class="skeleton-card" style="height: 20px"></div>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-12">
            <!-- Card -->
            <div class="card mb-4">
              <!-- Card header -->
              <div
                class="card-header align-items-center card-header-height d-flex justify-content-between align-items-center"
              >
                <div style="height: 40px;">
                  <h4 class="mb-0">
                    <div class="skeleton-card"></div>
                  </h4>
                </div>
                <div style="height: 40px;">
                  <div class="skeleton-card"></div>
                </div>
              </div>
              <!-- Card body -->
              <div class="card-body">
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
                <div style="height: 40px;" class="my-3">
                  <div class="skeleton-card"></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div *ngIf="!loading">
      <div class="container-fluid p-4">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="border-bottom pb-4 mb-4 d-lg-flex justify-content-between align-items-center"
            >
              <div class="mb-3 mb-lg-0">
                <h1 class="mb-0 h2 fw-bold">
                  {{'ADMIN_PORTAL' | translate}}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="row gx-3 mb-3">
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0 mb-2">
             <!-- Card -->
             <div class="card mb-4 h-100 d-flex flex-column justify-content-between ">
                <!-- Card body -->
                <div class=" card-body">
                   <span class="fs-6 text-uppercase fw-semibold">
                    {{'MENU.USERS' | translate}}
                   </span>
                   <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="lh-1">
                         <h2 class="h1 fw-bold mb-1">{{Users.length}}</h2>
                         <span>
                          
                          {{'ADMIN ' | translate}}{{Admins.length}}</span>
                      </div>
                      <div>
                         <span class="bg-primary icon-shape icon-md rounded-3 shadowfilter">
                          <i class="fa-solid fa-user-tie text-white"></i>
                        </span>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0 mb-2">
             <!-- Card -->
             <div class="card mb-4 h-100 d-flex flex-column justify-content-between">
                <!-- Card Body -->
                <div class=" card-body">
                   <span class="fs-6 text-uppercase fw-semibold">
                    P{{'MENU.NOTIFICATIONS' | translate}}
                   </span>
                   <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="lh-1">
                         <h2 class="h1 fw-bold mb-1">{{notifications.length}}</h2>
                         <span></span>
                      </div>
                      <div>
                         <span class="bg-pink icon-shape icon-md rounded-3 text-white shadowfilter">
                          <i class="fa-solid fa-bell" ></i>
                         </span>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0 mb-2">
             <!-- Card -->
             <div class="card mb-4 h-100 d-flex flex-column justify-content-between">
                <!-- Card Body -->
                <div class=" card-body">
                   <span class="fs-6 text-uppercase fw-semibold">
                    {{'MENU.APP_LOG' | translate}}
                   </span>
                   <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="lh-1">
                         <h2 class="h1 fw-bold mb-1">{{logs.length}}</h2>
                         <span></span>
                      </div>
                      <div>
                         <span class="bg-success icon-shape icon-md rounded-3 text-white shadowfilter">
                          <i class="fas fa-history text-white"></i>
                         </span>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-4 col-6 mb-3 mb-xl-0 mb-2">
             <!-- Card -->
             <div class="card mb-4 h-100 d-flex flex-column justify-content-between">
                <!-- Card Body -->
                <div class=" card-body">
                   <span class="fs-6 text-uppercase fw-semibold">
                    {{'MENU.PAYMENTS' | translate}}
                   </span>
                   <div class="mt-2 d-flex justify-content-between align-items-center">
                      <div class="lh-1">
                         <h2 class="h1 fw-bold mb-1">{{amount}}</h2>
                         <span></span>
                      </div>
                      <div>
                         <span class="bg-dark icon-shape icon-md rounded-3 text-white shadowfilter">
                          <i class="fa-solid fa-euro-sign text-white" ></i>
                        </span>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>

        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-12">
            <div class="card mb-4">
              <div class="card-header align-items-center card-header-height d-flex justify-content-between align-items-center" >
                <div>
                  <h2 class="mb-0">
                    {{"OVERVIEW" | translate}}
                  </h2>
                </div>
                <div>

                </div>
              </div>
              <!-- Card body -->
              <div class="card-body">
                <div *ngIf="loading">
                  <app-form-spinner></app-form-spinner>
                </div>
                <div *ngIf="!loading">
                  <div id="chart" *ngIf="logs.length>0">
                    <apx-chart
                      [series]="chartOptions.series!"
                      [chart]="chartOptions.chart!"
                      [dataLabels]="chartOptions.dataLabels!"
                      [plotOptions]="chartOptions.plotOptions!"
                      [yaxis]="chartOptions.yaxis!"
                      [xaxis]="chartOptions.xaxis!"
                      [legend]="chartOptions.legend!"
                      [colors]="chartOptions.colors!"
                      [grid]="chartOptions.grid!"
                    ></apx-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row my-3 mb-10">
          <div class="col-lg-3 d-flex mb-4" *ngFor="let user of Users">
            <div class="card card-bordered card-lift flex-fill py-3" [routerLink]="['/', user.name]"><div class="p-3 d-flex flex-column gap-3">
              <!--img-->
              <a *ngIf="user!=null" class="text-center">
              <img src="{{user.image}}" alt="mentor 1" class="img-fluid  rounded-4" style="height: 120px;">
              </a>
              <!--content-->
              <div class="d-flex flex-column gap-4">
              <div class="d-flex flex-column gap-2">
              <div>
              <div class="d-flex align-items-center gap-2">
              <h3 class="mb-0">
              <a  class="text-reset">{{ user.name}}</a>
              </h3>
              <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-patch-check-fill text-success" viewBox="0 0 16 16">
              <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
              </svg>
              </span>
              </div>
              <span class="text-gray-800">{{ user.roles }}</span>
              </div>
              <div>
                <span>
                  {{'profileTitle' | translate}}
                </span><br>
                <span>{{user.title}}</span>
              </div>

              </div>
              <div class="d-flex flex-row justify-content-between align-items-center">
              <div>
              <span>
                {{'userType' | translate}}
              </span>
              <div class="d-flex flex-row gap-1 align-items-center">
              <h4 class="mb-0">{{user.userType}}</h4>
              </div>
              </div>
              <div>
              <a [routerLink]="['/', user.name]" class="btn btn-outline-primary" >
                {{"viewProfile" | translate}}
              </a>
              </div>
              </div>
              </div>
              </div>
              </div>
          </div>
         
      </div>
    </div>
    </div>
  </section>
</main>
<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>
